/**
 * PerplayAdminApi
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 *
 */

import ApiClient from '../ApiClient';

/**
 * The SystemControllerDtoMnGnbDetailRequest model module.
 * @module model/SystemControllerDtoMnGnbDetailRequest
 * @version 1.0
 */
class SystemControllerDtoMnGnbDetailRequest {
    /**
     * Constructs a new <code>SystemControllerDtoMnGnbDetailRequest</code>.
     * @alias module:model/SystemControllerDtoMnGnbDetailRequest
     * @param gnbNo {Number} 
     */
    constructor(gnbNo) { 
        
        SystemControllerDtoMnGnbDetailRequest.initialize(this, gnbNo);
    }

    /**
     * Initializes the fields of this object.
     * This method is used by the constructors of any subclasses, in order to implement multiple inheritance (mix-ins).
     * Only for internal use.
     */
    static initialize(obj, gnbNo) { 
        obj['gnbNo'] = gnbNo;
    }

    /**
     * Constructs a <code>SystemControllerDtoMnGnbDetailRequest</code> from a plain JavaScript object, optionally creating a new instance.
     * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
     * @param {Object} data The plain JavaScript object bearing properties of interest.
     * @param {module:model/SystemControllerDtoMnGnbDetailRequest} obj Optional instance to populate.
     * @return {module:model/SystemControllerDtoMnGnbDetailRequest} The populated <code>SystemControllerDtoMnGnbDetailRequest</code> instance.
     */
    static constructFromObject(data, obj) {
        if (data) {
            obj = obj || new SystemControllerDtoMnGnbDetailRequest();

            if (data.hasOwnProperty('gnbNo')) {
                obj['gnbNo'] = ApiClient.convertToType(data['gnbNo'], 'Number');
            }
        }
        return obj;
    }

    /**
     * Validates the JSON data with respect to <code>SystemControllerDtoMnGnbDetailRequest</code>.
     * @param {Object} data The plain JavaScript object bearing properties of interest.
     * @return {boolean} to indicate whether the JSON data is valid with respect to <code>SystemControllerDtoMnGnbDetailRequest</code>.
     */
    static validateJSON(data) {
        // check to make sure all required properties are present in the JSON string
        for (const property of SystemControllerDtoMnGnbDetailRequest.RequiredProperties) {
            if (!data[property]) {
                throw new Error("The required field `" + property + "` is not found in the JSON data: " + JSON.stringify(data));
            }
        }

        return true;
    }


}

SystemControllerDtoMnGnbDetailRequest.RequiredProperties = ["gnbNo"];

/**
 * @member {Number} gnbNo
 */
SystemControllerDtoMnGnbDetailRequest.prototype['gnbNo'] = undefined;






export default SystemControllerDtoMnGnbDetailRequest;

